import { formatSearchPath } from '../services/util/index.js';

class {
  onCreate() {
    const yearList = [];
    const currentYear = new Date().getFullYear();

    for (let index = 2015; index <= currentYear; index++) {
      yearList.push(index);
    }

    this.state = {
      yearList
    }
  }
}

$ const {
  search
} = input;

style.scss {
  @use '../style/mixins' as mx;

  .page-header {
    padding: 2rem 0;
    background-color: var(--color-primary-darker);
    color: var(--white);

    &__title {
      margin-bottom: 2rem;

      &__subject {
        display: inline-block;
        position: relative;

        &:after {
          content: '';
          display: block;
          position: absolute;
          bottom: -0.25rem;
          left: 0;
          width: 100%;
          border-bottom: 1px solid var(--white);
        }
        &:not(.uppercase) {
          text-transform: capitalize;
        }
      }
    }
    &__years {
      display: flex;
      align-items: center;
      padding: 0;
      list-style: none;

      @include mx.mq(max-large) {
        flex-wrap: wrap;
        gap: 1rem;
      }
      @include mx.mq(large) {
        justify-content: flex-end;
        gap: 0.5rem;
      }

      &__link {
        color: var(--white);

        &:hover,
        &.active {
          color: var(--color-primary-light);
        }
      }
    }
  }
}

<section class="page-header">
  <div class="container">
    <h1 class="page-header__title kreon-300">
      <if(search.year)>
        List of hackathons 
      </if>
      <else>
        Upcoming hackathons 
      </else>
      <if(search.type === 'theme')>
        about 
      </if>
      <else-if(search.type === 'organizer')>
        organized by 
      </else-if>
      <else-if(search.type === 'online')>
        happening 
      </else-if>
      <else>
        in 
      </else>
      <span class=['page-header__title__subject', { uppercase: search.searchTerm.length <= 3 }]>${search.searchTerm}</span> 
      <if(search.year)>
        in ${search.year}
      </if>
    </h1>
    <ul class="page-header__years">
      <for|year| of=state.yearList>
        <li>
          <a
            class=['page-header__years__link', { active: parseInt(search.year, 10) === year }]
            href=formatSearchPath(search, year)
          >
            ${year}
          </a>
        </li>
      </for>
      <li>
        <a
          class=['page-header__years__link', { active: !search.year }]
          href=formatSearchPath(search)
        >
          Upcoming
        </a>
      </li>
    </ul>
  </div>
</section>
